import { createFileRoute } from '@tanstack/react-router';
import { InventorySettingsPage } from '@/features/inventory/pages/settings-page';

export const Route = createFileRoute('/_app/settings/inventory')({ component: InventorySettingsPage });
